RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const LinksPostedCompanyCountCell = _.defaults({
        getPopover: function (data, metric, metrics) {
            return new RivalIQ.views.metric.CompanyCountCellPopover({
                popoverName: metric.clone({
                    property: 'title',
                    canonicalUrl: data[0]
                }).getValue(),
                data: data,
                metrics: metrics
            });
        }
    }, RivalIQ.views.metric.CompanyCountCell);

    const LinksPostedTable = Dashboard.widgets.MetricTable.mixin({
        mixins: {
            LinksPosted: App.mixins.LinksPostedTableMixin
        },

        className: function () {
            const me = this;
            return ['links-posted-widget', Dashboard.widgets.MetricTable.prototype.className.apply(me, arguments)].join(' ');
        },

        getFetchAttributes: function () {
            const me = this;

            let fetchAttributes = RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.getFetchAttributes.apply(me, arguments);

            fetchAttributes = _.reduce(['limit', 'sortOrder', 'orderBy'], function (memo, attrName) {
                memo[`canonicalUrl${_.upperFirst(attrName)}`] = fetchAttributes[attrName];
                return memo;
            }, {});

            return fetchAttributes;
        }
    });

    const LinksPosted = Dashboard.widgets.TableWidget.mixin({

        mixins: {
            LinksTableWidgetCsv: App.mixins.LinksTableWidgetCsv
        },

        title: RivalIQ.strings.social_post_links_posted_title,
        description: RivalIQ.strings.social_post_links_posted_description,
        view: LinksPostedTable,
        footerView: Dashboard.views.PanelFooter.extend({
            template: '#socialPostsLinksPostedFooterTemplate',
            className: 'panel-footer'
        }),
        hasFooter: _.constant(true),

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                domainsOnly: true,
                orderBy: [1, 2],
                showDescriptions: true,
                sortable: true,
                sortOrder: 1,
                metrics: [
                    {
                        name: 'URL',
                        property: 'name'
                    },
                    {
                        property: 'companies_using',
                        cellView: _.constant(LinksPostedCompanyCountCell)
                    },
                    {
                        property: 'count',
                        description: RivalIQ.strings.activity_with_urls_urls_description
                    },
                    {
                        property: 'avg_engagement_rate_per_post'
                    }
                ]
            });

            if (!me.metric) {
                me.metric = new RivalIQ.models.MetricDefinition({
                    concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id,
                    dimensions: ['canonicalUrl']
                });
            }

            App.utils.updateMetric(me.metric, props);

            me.metricsCollection = RivalIQ.models.MetricDefinition.buildMetric(me.metric, props.metrics);
            me.metrics = me.metricsCollection.toJSON();

            return props;
        },
        filter: function () {
            const me = this;
            return !RivalIQ.props.channelAccess(me.getProps());
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_LINKS_POSTED_TABLE, LinksPosted);

});
